import cn from 'clsx'
import {Space} from 'antd'

import styles from './StatusHistory.module.scss'
import {CheckCircleIcon} from 'common/components'
import {formatDate} from 'common/helpers'
import {REQUEST_STATUS_NAME, RequestStatus} from '..'

interface StatusHistoryProps {
  declined?: boolean
  finished?: boolean
  statusHistory: any[]
}

export default function StatusHistory({
  declined,
  finished,
  statusHistory,
}: StatusHistoryProps) {
  const newStatusHistory =
    !finished && declined
      ? statusHistory.filter((item) => item.status !== 'declined')
      : statusHistory.slice()
  const reversedStatusHistory = newStatusHistory.reverse()

  return (
    <ul className={finished ? styles.finished : undefined}>
      {reversedStatusHistory.map((item, index, arr) => (
        <li
          key={item.status}
          className={cn(
            styles.step,
            !finished &&
              declined &&
              index === arr.length - 1 &&
              styles.step_declined
          )}
        >
          <Space className={styles.status} size={6}>
            <CheckCircleIcon />
            <span>{REQUEST_STATUS_NAME[item.status as RequestStatus]}</span>
          </Space>
          <span className={styles.date}>
            {formatDate(item.createdAt, 'third')}
          </span>
        </li>
      ))}
    </ul>
  )
}
